// services/adviceService.js - REPLACES ALL ENGINES
import api from './api';

export const adviceService = {
    // Single call that replaces all client-side engines
    async generateCompleteAdvice(clientProfile) {
        const response = await api.post('/api/v1/recommendations/generate-advice', clientProfile);
        return response.data;
    },

    // Individual engine replacements if needed
    async getFundRecommendations(clientProfile) {
        const response = await api.post('/api/v1/recommendations/fund-recommendations', clientProfile);
        return response.data;
    },

    async getContributionAdvice(clientProfile) {
        const response = await api.post('/api/v1/recommendations/contribution-advice', clientProfile);
        return response.data;
    }
};